import { render } from "./LeaderboardPrivate.vue?vue&type=template&id=1b5ee1e6&scoped=true"
import script from "./LeaderboardPrivate.vue?vue&type=script&lang=js"
export * from "./LeaderboardPrivate.vue?vue&type=script&lang=js"

import "./LeaderboardPrivate.vue?vue&type=style&index=0&id=1b5ee1e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5ee1e6"]])

export default __exports__